
export enum ConfigIntervalNameUpper{
    MFrom = "MFrom",
    MTo = "MTo",
    EFrom = "EFrom",
    ETo = "ETo"
}
export const intervalsUpper = ["MFrom", "MTo", "EFrom", "ETo"];

export enum ConfigIntervalNameLower{
    mFrom = "mFrom",
    mTo =  "mTo",
    eFrom = "eFrom",
    eTo = "eTo"
}
export const intervalsLower = ["mFrom", "mTo", "eFrom", "eTo"];
